import { render, staticRenderFns } from "./aliExpress.vue?vue&type=template&id=27fe9857&scoped=true&"
import script from "./aliExpress.vue?vue&type=script&lang=js&"
export * from "./aliExpress.vue?vue&type=script&lang=js&"
import style0 from "./aliExpress.vue?vue&type=style&index=0&id=27fe9857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe9857",
  null
  
)

export default component.exports